module.exports = __webpack_public_path__ + "static/media/contact-us-icon.e1cdd64a.svg";